export class CpfUtils {
	static mask: string = '000.000.000-00';

	static pattern: string =
		'^([0-9]{3}.?[0-9]{3}.?[0-9]{3}-?[0-9]{2}|[0-9]{2}.?[0-9]{3}.?[0-9]{3}/?[0-9]{4}-?[0-9]{2})$';
}
